import keycloakAxios from '@/services/axios';
import {OdooCompany} from '@/types/payments';

export const createOdooCompany = async (data: OdooCompany) => {
  const dataToSend = {
    ...data,
    logo: data.logo ? data.logo.split(',')[1] : null
  };

  const response = await keycloakAxios.post(
    'payments/odoo-company',
    dataToSend,
    {
      timeout: 60000
    }
  );

  if (response.status >= 300) {
    throw new Error(
      `Error creating odoo company: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
